import { useEffect } from "react";

function RightCheckOut({ totalPrice, cart, priceWithTaxes }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-5 px-5 w-100">
      <table className="py-2">
        <tbody>
          {cart.map((product) => (
            <tr key={product.id}>
              <td className="py-2">
                <div className="position-relative">
                  <img
                    src={
                      process.env.REACT_APP_IMAGES_URL +
                      "/" +
                      product.images.img1
                    }
                    className="product-thumbnail border rounded"
                    alt={product.name}
                  />
                  <div className="product-qty position-absolute rounded-circle bg-secondary text-white f-roboto">
                    {product.qty}
                  </div>
                </div>
              </td>
              <td>
                <p className="mb-0 fw-normal fs-8 px-3 py-2">{product.name}</p>
              </td>
              <td>
                <p className="f-roboto fs-7 fw-bold">
                  ${(product.price * product.qty).toFixed(2)}
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <hr />
      <table className="w-100 f-roboto">
        <caption className="visually-hidden">Cost summary</caption>
        <thead>
          <tr>
            <th scope="col">
              <span className="visually-hidden">Description</span>
            </th>
            <th scope="col">
              <span className="visually-hidden">Price</span>
            </th>
          </tr>
        </thead>
        <tbody className="total-line-table__tbody">
          <tr className="total-line total-line--subtotal">
            <th className="fw-normal" scope="row">
              Subtotal
            </th>
            <td className="text-end">
              <span>${totalPrice}</span>
            </td>
          </tr>
          <tr className="total-line total-line--shipping">
            <th className="fw-normal" scope="row">
              <span>Shipping</span>
            </th>
            <td className="text-end">
              <span>Free shipping</span>
            </td>
          </tr>
          <tr className="total-line total-line--shipping">
            <th className="fw-normal pb-4" scope="row">
              <span>Taxes</span>
            </th>
            <td className="pb-4 text-end">
              <span>+10%</span>
            </td>
          </tr>
          <tr className="visually-hidden">
            <th scope="row">Taxes (estimated)</th>
            <td>
              <span>$0.00</span>
            </td>
          </tr>
        </tbody>
        <tfoot className="border-top">
          <tr className="total-line">
            <th className="pt-4" scope="row">
              <span className="fw-normal">Total</span>
            </th>
            <td className="text-end pt-4">
              <span className="fs-8">CAD</span>
              <span className="fs-4 fw-bold ms-2">${priceWithTaxes}</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default RightCheckOut;
